import { render, staticRenderFns } from "./channel-private.vue?vue&type=template&id=52e9e792&scoped=true"
import script from "./channel-private.vue?vue&type=script&lang=js"
export * from "./channel-private.vue?vue&type=script&lang=js"
import style0 from "./channel-private.vue?vue&type=style&index=0&id=52e9e792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9e792",
  null
  
)

export default component.exports